import { render } from "./AttributeView.vue?vue&type=template&id=1bd621de"
import script from "./AttributeView.vue?vue&type=script&lang=js"
export * from "./AttributeView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__